import React from 'react';
import { motion } from 'framer-motion';
import { Users, Award, Globe, Briefcase, ShieldCheck, GraduationCap } from 'lucide-react';
import { GlassCard } from './GlassCard';
import { cn } from '../utils/cn';
const metrics = [{
  label: 'Students Trained',
  value: '1000+',
  icon: Users,
  color: 'text-primary-blue'
}, {
  label: 'Career Success',
  value: '95%',
  icon: Briefcase,
  color: 'text-accent-cyan'
}, {
  label: 'Expert Faculty',
  value: '25+',
  icon: ShieldCheck,
  color: 'text-status-success'
}, {
  label: 'Global Network',
  value: '12+',
  icon: Globe,
  color: 'text-accent-blue'
}, {
  label: 'Certifications',
  value: '15+',
  icon: Award,
  color: 'text-status-warning'
}, {
  label: 'Live Classes',
  value: '24/7',
  icon: GraduationCap,
  color: 'text-white'
}];
export function TrustSection() {
  return <section className="py-20 relative overflow-hidden" data-id="element-310">
      <div className="container mx-auto px-6" data-id="element-311">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-312">
          {metrics.map((metric, i) => <motion.div key={metric.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-313">
              <GlassCard className="p-6 text-center group h-full flex flex-col items-center justify-center border-white/5 hover:border-white/20 transition-all" data-id="element-314">
                <div className={cn('mb-4 p-3 rounded-xl bg-white/5 group-hover:scale-110 transition-transform', metric.color)} data-id="element-315">
                  <metric.icon size={24} data-id="element-316" />
                </div>
                <div className="text-2xl md:text-3xl font-bold text-white mb-1 font-heading" data-id="element-317">
                  {metric.value}
                </div>
                <div className="text-[10px] md:text-xs uppercase tracking-widest text-white/40 font-bold" data-id="element-318">
                  {metric.label}
                </div>
              </GlassCard>
            </motion.div>)}
        </div>
      </div>
    </section>;
}